import { getCommonQuickNavPages } from "constants/quickNav/common";
import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { SETTINGS_QUICK_NAV_PAGES } from "constants/quickNav/settings";
import { QuickNavPage } from "constants/quickNav/types";

const COMMUNITY_HOME_PATH = "/community";

export const COMMUNITY_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Home", path: COMMUNITY_HOME_PATH },
  { name: "Perks", path: "/community/perks" },
  { name: "Handbooks", path: "/community/handbook" },
  ...getCommonQuickNavPages(COMMUNITY_HOME_PATH),
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES.filter(({ path }) => path !== COMMUNITY_HOME_PATH),
];
